import { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import { sourcingData } from '../../data/sourcingData';

const SourcingCapabilities = ({ categories = [], loading = false }) => {
  const [displayData, setDisplayData] = useState([]);

  // Use Firestore data if available, otherwise use static data
  useEffect(() => {
    try {
      if (categories && Array.isArray(categories) && categories.length > 0) {
        console.log('Using Firestore categories:', categories);
        setDisplayData(categories);
      } else {
        console.log('Using static categories (no Firestore data)');
        setDisplayData(sourcingData);
      }
    } catch (err) {
      console.error('Error setting display data:', err);
      setDisplayData(sourcingData);
    }
  }, [categories]);

  if (!displayData || !Array.isArray(displayData)) {
    return (
      <section className="relative w-full bg-[#f4f4f4] py-16 px-6 md:px-12">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center py-10">
            <p className="text-gray-500">Loading sourcing capabilities...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="relative w-full bg-[#f4f4f4] py-16 px-6 md:px-12 overflow-hidden">

      {/*  Background Watermark  */}
      <div className="absolute top-0 right-0 z-0 pointer-events-none select-none">
        <img
          src={"./images/a.png"}
          alt=""
          className="w-[300px] md:w-[600px] h-auto object-contain opacity-[0.06] transform translate-x-1/4 -translate-y-1/4 md:translate-x-0 md:translate-y-0"
        />
      </div>

      {/* Main Content Wrapper  */}
      <div className="relative z-10 max-w-[1440px] mx-auto">

        {/* Section Header */}
        <h2 className="text-4xl md:text-5xl mb-16 font-normal">
          <span className=" text-gray-900">Our Sourcing</span>{" "}
          <span className=" text-[#737373]">Capabilities</span>
        </h2>

        <p className="text-gray-500 max-w-2xl mb-12 -mt-10 font-medium">
          We specialize in providing tailored corporate and professional sourcing propositions to clients around the globe.
        </p>

        {/* Categories Loop */}
        <div className="space-y-20">
          {displayData.map((category) => (
            <div
              key={category.id}
              id={category.id} //  1. Assign unique ID from data
              className="flex flex-col scroll-mt-32" //  2. Add scroll margin to account for sticky header
            >

              {/* Category Header */}
              <div className="mb-8 border-b border-gray-200/60 pb-4">
                <h2 className="text-2xl md:text-3xl font-normal text-gray-900 mb-2">
                  {category.title || category.categoryTitle}
                </h2>
                <p className="text-gray-500 text-sm md:text-base font-medium max-w-3xl">
                  {category.subtitle || category.categoryDescription}
                </p>
              </div>

              {/* Products Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {category.items && Array.isArray(category.items) && category.items.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SourcingCapabilities;